import { useFormContext } from "react-hook-form";

function CheckboxWithLabel({ label, name, showCheckbox, onChange }: any) {
  if (!showCheckbox) return null;
  const { register, setValue } = useFormContext();

  const handleChange = (e: any) => {
    if (onChange) onChange(e);
    setValue(name, e.target.checked);
  };
  return (
    <div className="mr-5">
      <label className="d-flex mb-0" htmlFor={name}>
        <div className="d-flex cursor-pointer checkbox bg-transparent">
          <input type="checkbox" className="d-none" {...register(name)} id={name} onChange={handleChange} />
          <span className="border-dark border-solid border-1 mr-2 position-relative br-3 checkbox__box" />
        </div>
        {label}
      </label>
    </div>
  );
}

export default CheckboxWithLabel;
